import cn from 'clsx';

import styles from './Menu.module.scss';

import type { ReactNode } from 'react';

export type MenuProps = {
  items: { label: ReactNode; onClick?: VoidFunction }[];
  className?: string;
};

export const Menu = ({ className, items }: MenuProps) => {
  return (
    <ul className={cn(styles.menu, className)} data-test-id="menu-container">
      {items.map((item, index) => (
        <li
          className={styles.item}
          onClick={item.onClick}
          key={index}
          data-test-id={`menu-item-${index}`}
        >
          {item.label}
        </li>
      ))}
    </ul>
  );
};
